import { forwardRef } from "react"
import { flexCss } from "../../Flex"
import { styled } from "../../styles"

const StyledContainer = styled.div({
  ...flexCss,
  width: `100%`,
  flexGrow: 0,
  flexDirection: `column`,
})

export const Container = forwardRef<HTMLDivElement, {}>(({ ...props }: {}, forwardedRef) => (
  <StyledContainer ref={forwardedRef} {...props} />
))
